import { SessionProfileActionTypes } from '~/actions/session';

const initialState = {
  webVersion: '',
  damList: [],
};

export default (state = initialState, action) => {
  const { type, ...param } = action;

  // `action.type`
  switch (type) {
    case SessionProfileActionTypes.LOAD:
      if (Object.prototype.hasOwnProperty.call(param, 'version')) {
        const { version, damList } = param;
        return { ...state, webVersion: version, damList };
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/webConfig.js